export const PREFETCH_RESERVA = 3;

const PREFIXO = 'digitacao:reserva:';

const TTL_FALLBACK_SEGUNDOS = 10 * 60;

const MARGEM_EXPIRACAO_MS = 5 * 1000;

const chaveDe = mode => `${PREFIXO}${mode}`;

const obterStore = () => {
    try {
        return window.localStorage;
    } catch (e) {
        return null;
    }
};

const ler = mode => {
    const store = obterStore();

    if (!store) return [];

    try {
        const bruto = store.getItem(chaveDe(mode));
        const itens = bruto ? JSON.parse(bruto) : [];

        return Array.isArray(itens) ? itens : [];
    } catch (e) {
        return [];
    }
};

const gravar = (mode, itens) => {
    const store = obterStore();

    if (!store) return;

    try {
        store.setItem(chaveDe(mode), JSON.stringify(itens));
    } catch (e) {
        return;
    }
};

const calcularExpiraEm = prova => {
    if (prova && prova.reservadoAte) {
        const alvo = new Date(prova.reservadoAte).getTime();

        if (!Number.isNaN(alvo)) return alvo;
    }

    return Date.now() + TTL_FALLBACK_SEGUNDOS * 1000;
};

const valido = item => Boolean(item) && item.expiraEm - Date.now() > MARGEM_EXPIRACAO_MS;

const descartarVencidos = mode => {
    const validos = ler(mode).filter(valido);

    gravar(mode, validos);

    return validos;
};

const DigitacaoReservaStorage = {
    quantidade: mode => descartarVencidos(mode).length,

    ids: mode => descartarVencidos(mode).map(item => item.prova.id),

    adicionar: (mode, prova) => {
        if (!prova || !prova.id) return;

        const itens = descartarVencidos(mode).filter(item => item.prova.id !== prova.id);

        itens.push({ prova, expiraEm: calcularExpiraEm(prova) });
        gravar(mode, itens);
    },

    adicionarVarias: (mode, provas) => {
        if (!Array.isArray(provas) || !provas.length) return;

        const recebidas = provas.filter(prova => prova && prova.id);

        if (!recebidas.length) return;

        const idsRecebidos = new Set(recebidas.map(prova => prova.id));
        const itens = descartarVencidos(mode).filter(item => !idsRecebidos.has(item.prova.id));

        recebidas.forEach(prova => itens.push({ prova, expiraEm: calcularExpiraEm(prova) }));

        gravar(mode, itens);
    },

    proxima: mode => {
        const itens = descartarVencidos(mode);

        if (!itens.length) return null;

        const [proximo, ...resto] = itens;

        gravar(mode, resto);

        return proximo.prova;
    },

    remover: (mode, idProva) => gravar(mode, ler(mode).filter(item => item.prova.id !== idProva)),

    limpar: mode => gravar(mode, []),
};

export default DigitacaoReservaStorage;
